var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.824 20.3273C33.824 19.3062 33.7324 18.3244 33.5622 17.3818H20V22.952H27.7498C27.416 24.752 26.4015 26.2771 24.8764 27.2982V30.9113H29.5302C32.2531 28.4044 33.824 24.7127 33.824 20.3273Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 34.4001C23.8877 34.4001 27.1473 33.1106 29.5299 30.9114L24.8761 27.2983C23.5866 28.1623 21.9372 28.6728 19.9997 28.6728C16.2492 28.6728 13.0746 26.1397 11.9423 22.7361H7.13135V26.467C9.5008 31.1732 14.3706 34.4001 19.9997 34.4001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9426 22.7361C11.6546 21.8721 11.491 20.9492 11.491 20.0001C11.491 19.051 11.6546 18.1281 11.9426 17.2641V13.5332H7.13173C6.15646 15.4772 5.6001 17.6765 5.6001 20.0001C5.6001 22.3237 6.15646 24.523 7.13173 26.467L11.9426 22.7361Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9997 11.3274C22.1139 11.3274 24.0121 12.0539 25.5044 13.4808L29.6346 9.35064C27.1408 7.02701 23.8812 5.6001 19.9997 5.6001C14.3706 5.6001 9.5008 8.82701 7.13135 13.5332L11.9423 17.2641C13.0746 13.8605 16.2492 11.3274 19.9997 11.3274Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.60ed524bda835dfa178c04c55df90480.svg";
export { ForwardRef as ReactComponent };